/**
 * The text half of the 28/32/42 control ladder. Keys are control sizes, which deliberately do
 * NOT match the type scale's names: control `medium` is 13px (`font-size-small`, not `-medium`
 * at 14px) and control `large` is the off-ladder 15px rung, not `font-size-large` at 16px.
 */
export type ControlSize = 'small' | 'medium' | 'large';

export const CONTROL_TEXT_SIZE_CLASS: Record<ControlSize, string> = {
    small: 'text-[length:var(--malachite-font-size-small,13px)]',
    medium: 'text-[length:var(--malachite-font-size-small,13px)]',
    large: 'text-[length:var(--malachite-font-size-15,15px)]',
};

/** For the panels, which portal outside the shadow root and so cannot use the classes. */
export const CONTROL_TEXT_SIZE: Record<ControlSize, string> = {
    small: 'var(--malachite-font-size-small, 13px)',
    medium: 'var(--malachite-font-size-small, 13px)',
    large: 'var(--malachite-font-size-15, 15px)',
};
